// extracted by mini-css-extract-plugin
export default {"installableAppAccessRadioButtonsContainer":"installableAppAccessRadioButtonsContainer__G6MPi","installableAppAccessLabelContainer":"installableAppAccessLabelContainer__Q5y9G"};